import { render, staticRenderFns } from "./type0.vue?vue&type=template&id=fb51a646&"
import script from "./type0.vue?vue&type=script&lang=js&"
export * from "./type0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports